import * as React from 'react'
import { connect } from 'react-redux'
import { NodeApi, Tree } from 'react-arborist';
import { AppState } from '../store'
import { showNewsModal, showConfirmModal, showNewsCenterModal } from '../store/modals/actions'
import ScrollToTopOnMount from '../components/Effects/ScrollToTopOnMount'
import PageLoader from '../components/Page/PageLoader'
import { Helmet } from 'react-helmet';
import { withTranslation, WithTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router';
import { News, BrowserSize, CurrentUser, NewsCenterLink, PublicLocale, NewsCenterPage, NewsCenter as NewsCenterType, MimeTypes, NewsCenterTreeData, NewsCenterTreeModelType, } from '../types';
import TopNavigation from '../components/Navigation/TopNavigation';
import FullPageContent from '../components/Page/FullPageContent'
import styled, { css } from 'styled-components'
import { Style } from '../styles'
import PowerSelect from '../components/Form/PowerSelect'
import ResizeObserver from '../components/ResizeObserver/ResizeObserver';
import { NewsCentersController, NewsController } from '../controllers';
import CardEmptyInfo from '../components/Card/CardEmptyInfo';
import Card from '../components/Card/Card';
import IconButton from '../components/Button/IconButton';
import Breadcrumb from '../components/Breadcrumb/Breadcrumb';
import ButtonGroup from '../components/Button/ButtonGroup';
import Accordion from '../components/Accordion/Accordion';
import copy from 'copy-to-clipboard';
import Notification from '../utilities/Notification';
import Utils from '../utilities/Utils';
import Tooltip from '../components/Tooltips/Tooltip';
import { Blob } from '@rails/activestorage';
import SwatchPicker from '../components/Swatch/SwatchPicker';
import CheckboxInput from '../components/Form/CheckboxInput';
import { HELP_CENTER_HERO_IMAGE_FILE_SIZE, HELPCENTER_LOGO_FILE_SIZE, HELPCENTER_OPEN_GRAPH_IMAGE_FILE_SIZE } from '../Constants';
import MobilityHelper from '../helpers/MobilityHelper';
import { DragDropContext, Draggable, Droppable, DropResult, ResponderProvided } from '@hello-pangea/dnd';
import DroppableHelper from '../helpers/DroppableHelper';
import AccordionContainer from '../components/Accordion/AccordionContainer';
import FaviconUpload from '../components/Form/FaviconUploader';
import AttachmentUploader from '../components/Form/AttachmentUploader';
import NewsCenterHelper from '../helpers/NewsCenterHelper';
import LinksBuilder from '../components/Form/LinksBuilder';
import Item from '../components/NewsCenter/Item';
import Button from '../components/Button/Button';
import SimpleTooltip from '@/components/Tooltips/SimpleTooltip'

const Container = styled.div`
 position: relative;
	display: flex;
	flex-direction: row;
	height: 100%;
	position: relative;

  @media screen and (max-width: ${Style.breakpoints.SMALL}) {
    flex-direction: column-reverse;
  }
`

const PageLoaderContainer = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Content = styled.div`
  padding: 0 ${Style.spacing.x2};
  flex: 1;
  overflow: auto;
  border-right: 1px solid ${Style.color.border};

  @media screen and (max-width: ${Style.breakpoints.SMALL}) {
    border-right: none;
    height: calc(50% - 106px);
  }
`

const Table = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid ${Style.color.border};
  border-radius: ${Style.variables.baseBorderRadius};
  overflow: hidden;

  @media screen and (max-width: ${Style.breakpoints.SMALL}) {
    height: 30vh;
  }
`

const TableHeading = styled.div`
  padding: 8px 16px;
  text-align: left;
  font-weight: 800;
  background: #f7f7fa;
  border-bottom: 1px solid ${Style.color.border};
`

const TableHeader = styled.div`
  display: flex;
  flex-direction: row;
  border-top-left-radius: ${Style.variables.baseBorderRadius};
  border-top-right-radius: ${Style.variables.baseBorderRadius};

  ${TableHeading} {
    &:first-child {
      flex: 1;
      flex-grow: 1;
    }
  }
`

const TableActions = styled(TableHeading)`
  width: 32px;
  max-width: 32px;
`

const TableRows = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: auto;
`

const Preview = styled.div`
  padding: 0 ${Style.spacing.x2};
  flex: 1;
  overflow: auto;

  @media screen and (max-width: ${Style.breakpoints.SMALL}) {
    height: calc(50% - 106px);
    border-bottom: 1px solid ${Style.color.border};
  }
`

const Header = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: ${Style.spacing.x3};
  padding-bottom: ${Style.spacing.x2};
  justify-content: space-between;
`

const BrowserPreview = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`

const BrowserUrl = styled.div`
  display: block;
  padding: 3px 40px;
  text-align: center;
  border: 1px solid ${Style.color.border};
  border-radius: 30px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  background: white;
  max-width: 325px; 

  @media screen and (max-width: ${Style.breakpoints.SMALL}) {
    max-width: initial;
  }
`

const BrowserContainer = styled.div<{ size?: 'mobile' | 'tablet' | 'desktop' }>`
  width: 100%;
  position: relative;

  ${props => props.size === BrowserSize.MOBILE && css`
    max-width: 290px;

    ${BrowserUrl} {
      padding-left: 10px;
      padding-right: 10px;
    }

    ${BrowserHeader} {
      &:after {
        display: none;
      }
    }
  `}

  ${props => props.size === BrowserSize.TABLET && css`
    max-width: 380px;

    ${BrowserUrl} {
      padding-left: 10px;
      padding-right: 10px;
    }

    ${BrowserHeader} {
      &:after {
        display: none;
      }
    }
  `}

  ${props => props.size === BrowserSize.DESKTOP && css`
  `}
`

const Browser = styled.div`
  border-radius: 8px;
  border: 1px solid ${Style.color.border};
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 75vh;
  overflow: hidden;
  border-radius: 4px; 

  @media screen and (max-width: ${Style.breakpoints.SMALL}) {
    height: 30vh;
  }
`


const BrowserHeader = styled.div`
  position: relative;
  padding: 5px;
  width: 100%;
  color: #646462;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid ${Style.color.border};
  background: #f7f7fa;
  cursor: pointer;

  &:after {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 10px;
    font-size: 25px;
    line-height: 25px;
    color: #8080804f;
    content: '• • •';

    @media screen and (max-width: ${Style.breakpoints.SMALL}) {
      display: none;
    }
  }

  &:hover {
    ${BrowserUrl} {
      color: ${Style.color.brandPrimary};
    }
  }
`


const BrowserContentContainer = styled.div`
  position: absolute;
  transform-origin: top;
`

const BrowserContent = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  border-radius: 0 0 8px 8px;
`

const HeaderActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`

const SwatchPickerContainer = styled.div`
  width: 38px;
  height: 38px;
  border: 1px solid ${Style.color.border};
  border-radius: ${Style.variables.baseBorderRadius};
  overflow: hidden;
`

interface IStateToProps {
  currentUser: CurrentUser
}

interface IDispatchToProps {
  showNewsCenterModal: typeof showNewsCenterModal
  showNewsModal: typeof showNewsModal
  showConfirmModal: typeof showConfirmModal
}

type IProps = IStateToProps & IDispatchToProps & WithTranslation & RouteComponentProps<{ id: string }>

const enum NewsCenterViewMode {
  CONTENT = 'content',
  SETTINGS = 'settings',
}

const enum NewsCenterSubviewMode {
  GENERAL = 'general',
  STYLING = 'styling',
}

interface IState {
  viewMode: NewsCenterViewMode
  subviewMode: NewsCenterSubviewMode,
  newsCenter: NewsCenterType,
  news: News[],
  didInitialLoad: boolean,
  selectedLocale: PublicLocale,
  selectedPage: NewsCenterPage,
  browserSize: BrowserSize
  treeData: NewsCenterTreeData[]
  editLocale: PublicLocale
}

class NewsCenter extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      viewMode: NewsCenterViewMode.CONTENT,
      subviewMode: NewsCenterSubviewMode.GENERAL,
      newsCenter: null,
      news: [],
      didInitialLoad: false,
      selectedLocale: null,
      selectedPage: NewsCenterPage.HOMEPAGE,
      browserSize: BrowserSize.DESKTOP,
      treeData: [],
      editLocale: PublicLocale.EN,
    }

    this.fetchNewsCenterView = this.fetchNewsCenterView.bind(this)
    this.updateNewsCenter = this.updateNewsCenter.bind(this)
    this.updateNewsCenterDebounced = Utils.debounce(this.updateNewsCenter, 250, false)
    this.onNewsSubmit = this.onNewsSubmit.bind(this)
    this.onNewsDelete = this.onNewsDelete.bind(this)
    this.onSelectedLocaleChange = this.onSelectedLocaleChange.bind(this)
    this.onAddNewsItemClick = this.onAddNewsItemClick.bind(this)
    this.onItemMove = this.onItemMove.bind(this)
    this.onItemClick = this.onItemClick.bind(this)
    this.onItemEditClick = this.onItemEditClick.bind(this)
    this.onItemDeleteClick = this.onItemDeleteClick.bind(this)
    this.disableDrop = this.disableDrop.bind(this)
    this.onPageChange = this.onPageChange.bind(this)
    this.onSettingsClick = this.onSettingsClick.bind(this)
    this.onBrowserSizeChange = this.onBrowserSizeChange.bind(this)
    this.onExitSettingsClick = this.onExitSettingsClick.bind(this)
    this.onSubviewModeChange = this.onSubviewModeChange.bind(this)
    this.onNewsCenterCopyUrlClick = this.onNewsCenterCopyUrlClick.bind(this)
    this.renderGeneralSettings = this.renderGeneralSettings.bind(this)
    this.renderStylingSettings = this.renderStylingSettings.bind(this)
    this.onDefaultLocaleChange = this.onDefaultLocaleChange.bind(this)
    this.onSupportedLocalesChange = this.onSupportedLocalesChange.bind(this)
    this.onSlugChange = this.onSlugChange.bind(this)
    this.onCustomDomainChange = this.onCustomDomainChange.bind(this)
    this.onGoogleAnalyticsTrackingIdChange = this.onGoogleAnalyticsTrackingIdChange.bind(this)
    this.onFaviconChange = this.onFaviconChange.bind(this)
    this.onOpenGraphImageChange = this.onOpenGraphImageChange.bind(this)
    this.onBackgroundColorChange = this.onBackgroundColorChange.bind(this)
    this.onActionColorChange = this.onActionColorChange.bind(this)
    this.onShowNewsAuthorsChange = this.onShowNewsAuthorsChange.bind(this)
    this.onNewsCenterSettingLocaleChange = this.onNewsCenterSettingLocaleChange.bind(this)
    this.onLogoChange = this.onLogoChange.bind(this)
    this.onHeaderPageTitleChange = this.onHeaderPageTitleChange.bind(this)
    this.onHeaderLinksChange = this.onHeaderLinksChange.bind(this)
    this.onHeaderBackgroundColorChange = this.onHeaderBackgroundColorChange.bind(this)
    this.onHeaderTextColorChange = this.onHeaderTextColorChange.bind(this)
    this.onWelcomeMessageChange = this.onWelcomeMessageChange.bind(this)
    this.onHeroImageChange = this.onHeroImageChange.bind(this)
    this.onHeroBackgroundFadeChange = this.onHeroBackgroundFadeChange.bind(this)
    this.onHeroHeightChange = this.onHeroHeightChange.bind(this)
    this.onTableOfContentsEnabledChange = this.onTableOfContentsEnabledChange.bind(this)
    this.getPreviewUrl = this.getPreviewUrl.bind(this)
  }

  componentDidMount(): void {
    this.fetchNewsCenterView().catch(console.error)
  }

  async fetchNewsCenterView() {
    const { match: { params: { id } } } = this.props
    const { selectedLocale } = this.state

    try {
      const {
        news_center,
        news,
      } = await NewsCentersController.getView(id)

      const treeData: NewsCenterTreeData[] = this.getTreeData(news)

      this.setState({
        newsCenter: news_center,
        news: news,
        selectedLocale: selectedLocale || news_center.locale as PublicLocale,
        didInitialLoad: true,
        treeData: treeData,
        editLocale: news_center.locale as PublicLocale,
      })
    } catch (ex) {
      console.error(ex)
    }
  }

  async updateNewsCenter(newsCenter: NewsCenterType) {
    try {
      const response = await NewsCentersController.update(newsCenter)

      if (!response.errors) {
        this.setState({
          newsCenter: response
        })
      }
    } catch (ex) {
      console.error(ex)
    }
  }

  updateNewsCenterDebounced(newsCenter: NewsCenterType) {
    this.updateNewsCenter(newsCenter).catch(console.error)
  }

  getTreeData(news: News[]) {
    // Find root-level news (those without a collection or with invalid collection)
    const newsNodes = news.map(news => {
      return {
        type: NewsCenterTreeModelType.NEWS,
        model: news,
        children: null
      };
    });



    const rootNodes = [
      ...newsNodes
        .sort((a, b) => {
          const posA = a.model.position || 0;
          const posB = b.model.position || 0;
          return posB - posA;
        })
    ];

    return rootNodes;
  }

  onPageChange(option) {
    this.setState({ selectedPage: option.value })
  }

  onSettingsClick() {
    this.setState({
      viewMode: NewsCenterViewMode.SETTINGS,
      subviewMode: NewsCenterSubviewMode.GENERAL
    })
  }

  onBrowserSizeChange(option) {
    this.setState({ browserSize: option.value })
  }

  onExitSettingsClick(e) {
    e.preventDefault()

    this.setState({
      viewMode: NewsCenterViewMode.CONTENT,
      subviewMode: NewsCenterSubviewMode.GENERAL
    })
  }

  onSelectedLocaleChange(option) {
    this.setState({ selectedLocale: option.value, })
  }

  onAddNewsItemClick() {
    const { currentUser, showNewsModal } = this.props
    const { newsCenter, news, selectedLocale } = this.state

    requestAnimationFrame(() => {
      this.props.showNewsModal({
        newsCenterId: newsCenter.id,
        news: {
          author_id: currentUser.id,
          position: NewsCenterHelper.getCreatePosition(news),
        },
        locale: selectedLocale,
        onSubmit: this.onNewsSubmit,
        onDelete: this.onNewsDelete
      })
    })
  }

  async onItemMove(data: {
    dragIds: string[];
    dragNodes: NodeApi<NewsCenterTreeData>[];
    parentId: string | null;
    parentNode: NodeApi<NewsCenterTreeData>;
    index: number;
  }) {
    const { t } = this.props
    const { newsCenter, treeData, news } = this.state
    const { dragIds, dragNodes, parentId, parentNode, index } = data

    if (dragNodes.length === 0) return;

    const droppedNode = parentNode
    const draggedNode = dragNodes[0]
    const draggedNodeData = draggedNode.data;

    // Dropped on root level
    if (droppedNode === null) {
      const rootItems = treeData.map(item => item.model)
      const newPosition = NewsCenterHelper.getNewPositionBasedOnIndex(rootItems, index)
      const collection = draggedNode.data.model as News

      const updatedNewsItem = {
        ...collection,
        position: newPosition,
      }

      const newsIndex = news.findIndex(a => a.id === collection.id)

      const updatedNews = [...news]

      updatedNews[newsIndex] = updatedNewsItem

      // Update local copy
      this.setState({ news: updatedNews, treeData: this.getTreeData(updatedNews) })
      await NewsController.update(newsCenter.id, updatedNewsItem)
      await this.fetchNewsCenterView()
      return
    }
  }

  onItemClick(node: NewsCenterTreeData) {
    const { newsCenter, selectedLocale } = this.state

    switch (node.type) {
      case NewsCenterTreeModelType.NEWS:
        requestAnimationFrame(() => {
          this.props.showNewsModal({
            newsCenterId: newsCenter.id,
            news: { id: node.model.id },
            locale: selectedLocale,
            onSubmit: this.onNewsSubmit,
            onDelete: this.onNewsDelete
          })
        })
        break
    }
  }

  onNewsSubmit(news: News) {
    const { news: stateNews } = this.state

    const index = stateNews.findIndex(a => a.id === news.id)

    if (index !== -1) {
      stateNews[index] = news

      this.setState({
        news: [...stateNews],
        treeData: this.getTreeData(stateNews)
      }, this.fetchNewsCenterView)
    } else {
      const updatedNews = [...stateNews, news]

      this.setState({
        news: updatedNews,
        treeData: this.getTreeData(updatedNews)
      }, this.fetchNewsCenterView)
    }
  }

  onNewsDelete(news: News) {
    const { news: stateNews } = this.state

    const updatedNews = stateNews.filter(a => a.id !== news.id)

    this.setState({
      news: updatedNews,
      treeData: this.getTreeData(updatedNews)
    }, this.fetchNewsCenterView)
  }

  onItemEditClick(node: NewsCenterTreeData) {
    this.onItemClick(node)
  }

  onItemDeleteClick(node: NewsCenterTreeData) {
    const { t, showConfirmModal } = this.props
    const { newsCenter, news } = this.state

    switch (node.type) {
      case NewsCenterTreeModelType.NEWS:
        showConfirmModal({
          title: t('NewsCenter::Delete news'),
          description: t('NewsCenter::You are about to delete this news. Are you sure?'),
          action: { label: t('NewsCenter::Delete'), isDestructive: true },
          onConfirm: async () => {
            try {
              await NewsController.delete(newsCenter.id, node.model.id)

              const updatedNews = news.filter(news => news.id !== node.model.id)

              this.setState({
                news: updatedNews,
                treeData: this.getTreeData(updatedNews)
              }, this.fetchNewsCenterView)
            } catch (ex) {
              console.error(ex)
            }
          }
        })
        break
    }
  }

  disableDrop(data: {
    parentNode: NodeApi<NewsCenterTreeData>;
    dragNodes: NodeApi<NewsCenterTreeData>[];
    index: number;
  }) {
    const droppedNode = data.parentNode
    const droppedNodeData = droppedNode.data
    const draggedNode = data.dragNodes[0]

    if ( // Prevent moving items under an news (visually)
      droppedNodeData.type === NewsCenterTreeModelType.NEWS
    ) return true

    return false
  }

  onSubviewModeChange(subviewMode: NewsCenterSubviewMode) {
    this.setState({ subviewMode: subviewMode })
  }

  onNewsCenterCopyUrlClick() {
    const { t } = this.props

    copy(this.getPreviewUrl())
    Notification.notifySuccess(t('NewsCenter::Copied to clipboard'))
  }

  onDefaultLocaleChange(option) {
    const { newsCenter } = this.state

    const updatedNewsCenter: NewsCenterType = {
      ...newsCenter,
      locale: option.value,
    }

    this.setState({ newsCenter: updatedNewsCenter }, () => {
      this.updateNewsCenter(updatedNewsCenter)
    })
  }

  onSupportedLocalesChange(options) {
    const { newsCenter } = this.state

    const updatedNewsCenter: NewsCenterType = {
      ...newsCenter,
      supported_locales: options ? options.map(option => option.value) : [],
    }

    this.setState({ newsCenter: updatedNewsCenter }, () => {
      this.updateNewsCenter(updatedNewsCenter)
    })
  }

  onSlugChange(e: React.ChangeEvent<HTMLInputElement>) {
    const { newsCenter } = this.state
    const updatedNewsCenter: NewsCenterType = {
      ...newsCenter,
      slug: e.target.value,
    }

    this.setState({ newsCenter: updatedNewsCenter }, () => {
      this.updateNewsCenterDebounced(updatedNewsCenter)
    })
  }

  onCustomDomainChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { newsCenter } = this.state
    const updatedNewsCenter: NewsCenterType = {
      ...newsCenter,
      custom_domain: e.target.value,
    }

    this.setState({ newsCenter: updatedNewsCenter }, () => {
      this.updateNewsCenterDebounced(updatedNewsCenter)
    })
  }

  onGoogleAnalyticsTrackingIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { newsCenter } = this.state
    const updatedNewsCenter: NewsCenterType = {
      ...newsCenter,
      google_analytics_id: e.target.value,
    }

    this.setState({ newsCenter: updatedNewsCenter }, () => {
      this.updateNewsCenterDebounced(updatedNewsCenter)
    })
  }

  onFaviconChange(blob: Blob | null) {
    const { newsCenter } = this.state

    const updatedNewsCenter: NewsCenterType = {
      ...newsCenter,
      favicon: blob?.signed_id || null,
    }

    this.setState({ newsCenter: updatedNewsCenter }, () => {
      this.updateNewsCenterDebounced(updatedNewsCenter)
    })
  }

  onOpenGraphImageChange(blob: Blob | null) {
    const { newsCenter } = this.state

    const updatedNewsCenter: NewsCenterType = {
      ...newsCenter,
      open_graph_image: blob?.signed_id || null,
    }

    this.setState({ newsCenter: updatedNewsCenter }, () => {
      this.updateNewsCenterDebounced(updatedNewsCenter)
    })
  }

  onBackgroundColorChange(color: string) {
    const { newsCenter } = this.state
    const updatedNewsCenter: NewsCenterType = {
      ...newsCenter,
      background_color: color,
    }
    this.setState({ newsCenter: updatedNewsCenter }, () => {
      this.updateNewsCenterDebounced(updatedNewsCenter)
    })
  }

  onActionColorChange(color: string) {
    const { newsCenter } = this.state
    const updatedNewsCenter: NewsCenterType = {
      ...newsCenter,
      action_color: color,
    }
    this.setState({ newsCenter: updatedNewsCenter }, () => {
      this.updateNewsCenterDebounced(updatedNewsCenter)
    })
  }

  onShowNewsAuthorsChange() {
    const { newsCenter } = this.state

    const updatedNewsCenter: NewsCenterType = {
      ...newsCenter,
      show_news_authors: !newsCenter.show_news_authors,
    }

    this.setState({ newsCenter: updatedNewsCenter }, () => {
      this.updateNewsCenterDebounced(updatedNewsCenter)
    })
  }

  onNewsCenterSettingLocaleChange(option) {
    this.setState({ editLocale: option.value })
  }

  onLogoChange(blob: Blob | null) {
    const { newsCenter } = this.state

    const updatedNewsCenter: NewsCenterType = {
      ...newsCenter,
      logo: blob?.signed_id || null,
    }

    this.setState({ newsCenter: updatedNewsCenter }, () => {
      this.updateNewsCenterDebounced(updatedNewsCenter)
    })
  }

  onHeaderPageTitleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const { newsCenter } = this.state
    const updatedNewsCenter: NewsCenterType = {
      ...newsCenter,
      header_page_title: e.target.value,
    }
    this.setState({ newsCenter: updatedNewsCenter }, () => {
      this.updateNewsCenterDebounced(updatedNewsCenter)
    })
  }

  onHeaderLinksChange(links: NewsCenterLink[]) {
    const { newsCenter } = this.state
    const updatedNewsCenter: NewsCenterType = {
      ...newsCenter,
      header_links: links,
    }

    this.setState({ newsCenter: updatedNewsCenter }, () => {
      this.updateNewsCenterDebounced(updatedNewsCenter)
    })
  }

  onHeaderBackgroundColorChange(color: string) {
    const { newsCenter } = this.state
    const updatedNewsCenter: NewsCenterType = {
      ...newsCenter,
      header_background_color: color,
    }
    this.setState({ newsCenter: updatedNewsCenter }, () => {
      this.updateNewsCenterDebounced(updatedNewsCenter)
    })
  }

  onHeaderTextColorChange(color: string) {
    const { newsCenter } = this.state
    const updatedNewsCenter: NewsCenterType = {
      ...newsCenter,
      header_text_color: color,
    }
    this.setState({ newsCenter: updatedNewsCenter }, () => {
      this.updateNewsCenterDebounced(updatedNewsCenter)
    })
  }

  onWelcomeMessageChange(e) {
    const { newsCenter, editLocale } = this.state

    const updatedNewsCenter: NewsCenterType = {
      ...newsCenter,
      translations: MobilityHelper.updateTranslation(editLocale, newsCenter.translations, 'welcome_message', e.currentTarget.value),
    }

    this.setState({ newsCenter: updatedNewsCenter }, () => {
      this.updateNewsCenterDebounced(updatedNewsCenter)
    })
  }

  onHeroImageChange(blob: Blob | null) {
    const { newsCenter } = this.state
    const updatedNewsCenter: NewsCenterType = {
      ...newsCenter,
      header_image: blob?.signed_id || null,
    }

    this.setState({ newsCenter: updatedNewsCenter }, () => {
      this.updateNewsCenterDebounced(updatedNewsCenter)
    })
  }

  onHeroBackgroundFadeChange() {
    const { newsCenter } = this.state

    const updatedNewsCenter: NewsCenterType = {
      ...newsCenter,
      header_background_fade: !newsCenter.header_background_fade,
    }

    this.setState({ newsCenter: updatedNewsCenter }, () => {
      this.updateNewsCenterDebounced(updatedNewsCenter)
    })
  }

  onHeroHeightChange(e: React.ChangeEvent<HTMLInputElement>) {
    const { newsCenter } = this.state
    const updatedNewsCenter: NewsCenterType = {
      ...newsCenter,
      header_height: parseInt(e.target.value, 10) || 0,
    }
    this.setState({ newsCenter: updatedNewsCenter }, () => {
      this.updateNewsCenterDebounced(updatedNewsCenter)
    })
  }

  onTableOfContentsEnabledChange() {
    const { newsCenter } = this.state

    const updatedNewsCenter: NewsCenterType = {
      ...newsCenter,
      table_of_contents_enabled: !newsCenter.table_of_contents_enabled,
    }

    this.setState({ newsCenter: updatedNewsCenter }, () => {
      this.updateNewsCenterDebounced(updatedNewsCenter)
    })
  }

  renderGeneralSettings() {
    const { t } = this.props
    const { newsCenter, didInitialLoad, editLocale, news } = this.state

    const availableLocaleOptions = NewsCenterHelper.getAvailableLocaleOptions()
    const defaultLocaleOption = availableLocaleOptions.find(option => option.value === newsCenter.locale)

    const additionalLocaleOptions = availableLocaleOptions.filter(option => option.value !== newsCenter.locale)
    const selectedLocaleOptions = additionalLocaleOptions.filter(option => newsCenter.supported_locales.includes(option.value as PublicLocale))

    const supportedLocaleOptions = NewsCenterHelper.getSupportedLocaleOptions(newsCenter)
    const selectedLocaleOption = supportedLocaleOptions.find(option => option.value === String(editLocale))

    const newsOptions = news.map(news => ({
      label: MobilityHelper.getTranslation(editLocale, news.translations, 'title') || t('NewsCenter::Untitled'),
      value: news.id,
    }))


    return (
      <AccordionContainer>
        <Accordion title={t('NewsCenter::Supported languages')}>
          <div className='form-item'>
            <label>{t('NewsCenter::Default language')}</label>
            <PowerSelect
              options={availableLocaleOptions}
              value={defaultLocaleOption}
              onChange={this.onDefaultLocaleChange}
              placeholder={t('NewsCenter::Select default language')}
            />
          </div>

          <div className='form-item'>
            <label>{t('NewsCenter::Additional languages')}</label>
            <PowerSelect
              options={additionalLocaleOptions}
              value={selectedLocaleOptions}
              onChange={this.onSupportedLocalesChange}
              placeholder={t('NewsCenter::Select additional languages')}
              // @ts-ignore
              isMulti={true}
            />
          </div>
        </Accordion>

        <Accordion title={t('NewsCenter::Domains')}>
          <div className='form-item'>
            <label>{t('NewsCenter::Slug')}</label>
            <input
              type='text'
              value={newsCenter.slug}
              onChange={this.onSlugChange}
            />
          </div>
          <div className='form-item'>
            <label>{t('NewsCenter::Custom news center domain')}</label>
            <input
              type='text'
              value={newsCenter.custom_domain || ''}
              onChange={this.onCustomDomainChange}
              placeholder={t('NewsCenter::e.g. news.example.com')}
            />
          </div>
        </Accordion>

        <Accordion title={t('NewsCenter::Analytics')}>
          <div className='form-item'>
            <label>{t('NewsCenter::Google analytics tracking ID')}</label>
            <input
              type='text'
              value={newsCenter.google_analytics_id || ''}
              onChange={this.onGoogleAnalyticsTrackingIdChange}
              placeholder='UA-XXXXXXXXX-X'
            />
          </div>
        </Accordion>

        <Accordion title={t('NewsCenter::Social media images')}>
          <div className='form-item'>
            <label>
              {t('NewsCenter::Favicon')}
              <Tooltip
                content={t('NewsCenter::Recommended ratio: 1:1. 150KB max. This icon appears before the title on your customers\' browser tab.')}
                containerStyle={{ marginLeft: 8 }}
              />
            </label>

            <FaviconUpload
              url={newsCenter.favicon_url}
              onSubmit={this.onFaviconChange}
            />
          </div>

          <div className='form-item'>
            <label>
              {t('NewsCenter::Social media image')}
              <Tooltip
                content={t('NewsCenter::Recommended: 5:2 ratio, 2MB size. This is the image that appears when your Help Center is shared on Facebook, Twitter or any other social media. Recommended: 1.91:1 ratio, 2MB size, 1200 x 630 dimensions')}
                containerStyle={{ marginLeft: 8 }}
              />
            </label>

            <AttachmentUploader
              url={newsCenter.open_graph_image_url}
              onSubmit={this.onOpenGraphImageChange}
              maxSize={HELPCENTER_OPEN_GRAPH_IMAGE_FILE_SIZE}
              accept={[
                MimeTypes.PNG,
                MimeTypes.JPEG,
                MimeTypes.JPG,
                MimeTypes.WEBP
              ]}
            />
          </div>
        </Accordion>
      </AccordionContainer>
    )
  }

  renderStylingSettings() {
    const { t } = this.props
    const { newsCenter, editLocale } = this.state

    const supportedLocaleOptions = NewsCenterHelper.getSupportedLocaleOptions(newsCenter)
    const selectedLocaleOption = supportedLocaleOptions.find(option => option.value === String(editLocale))

    return (
      <AccordionContainer>
        <Accordion title={t('NewsCenter::Shared elements')}>
          <div className='form-item'>
            <label>{t('NewsCenter::Body background color')}</label>
            <p style={{ marginBottom: 8 }}>{t('NewsCenter::Applies to the background of all pages')}</p>
            <SwatchPickerContainer>
              <SwatchPicker
                color={newsCenter.background_color}
                onChange={this.onBackgroundColorChange}
              />
            </SwatchPickerContainer>
          </div>
          <div className='form-item'>
            <label>{t('NewsCenter::Action color')}</label>
            <p style={{ marginBottom: 8 }}>{t('NewsCenter::Used in buttons, links and other elements. Color will not update for icons uploaded in JPEG/PNG/GIF format.')}</p>
            <SwatchPickerContainer>
              <SwatchPicker
                color={newsCenter.action_color}
                onChange={this.onActionColorChange}
              />
            </SwatchPickerContainer>
          </div>
          <div className='form-item'>
            <label>
              {t('NewsCenter::Show news authors')}

              <Tooltip
                content={t('NewsCenter::Recommended: 5:1 ratio, 1MB size.')}
                containerStyle={{ marginLeft: 8 }}
              />
            </label>
            <p style={{ marginBottom: 8 }}>{t('NewsCenter::Author avatars make your News Center more personal')}</p>
            <div style={{ width: 'fit-content' }}>
              <CheckboxInput
                checked={newsCenter.show_news_authors}
                onChange={this.onShowNewsAuthorsChange}
                label={t('NewsCenter::Show news authors')}
              />
            </div>
          </div>
        </Accordion>

        <Accordion title={t('NewsCenter::Header')}>
          <div className='form-item'>
            <PowerSelect
              options={supportedLocaleOptions}
              value={selectedLocaleOption}
              onChange={this.onNewsCenterSettingLocaleChange}
              placeholder={t('NewsCenter::Select edit language')}
            />
          </div>

          <div className='form-item'>
            <label>
              {t('NewsCenter::Logo')}
              <Tooltip
                content={t('NewsCenter::Recommended: 5:1 ratio, 1MB size.')}
                containerStyle={{ marginLeft: 8 }}
              />
            </label>
            <AttachmentUploader
              url={newsCenter.logo_url}
              onSubmit={this.onLogoChange}
              maxSize={HELPCENTER_LOGO_FILE_SIZE}
              accept={[
                MimeTypes.PNG,
                MimeTypes.SVG,
                MimeTypes.JPEG,
                MimeTypes.JPG,
                MimeTypes.WEBP
              ]}
            />
          </div>

          <div className='form-item'>
            <label>
              {t('NewsCenter::Page title')}
              <Tooltip
                content={t('NewsCenter::The page title will appear in the top left corner of your Help Center unless a logo is specified.')}
                containerStyle={{ marginLeft: 8 }}
              />
            </label>
            <input
              type='text'
              value={newsCenter.header_page_title}
              onChange={this.onHeaderPageTitleChange}
              placeholder={t('NewsCenter::e.g. News Center')}
            />
          </div>

          <div className='form-item'>
            <label>
              {t('NewsCenter::Header links')}
              <Tooltip
                content={t('NewsCenter::You can add up to 3 links in the header, which will appear in the top right corner of your Help Center.')}
                containerStyle={{ marginLeft: 8 }}
              />
            </label>

            <div style={{ marginBottom: 8 }}>
              <LinksBuilder
                locale={editLocale}
                links={newsCenter.header_links}
                onChange={this.onHeaderLinksChange}
              />
            </div>
          </div>

          <div className='form-item'>
            <label>{t('NewsCenter::Welcome message')}</label>
            <input
              type='text'
              value={MobilityHelper.getTranslation(editLocale, newsCenter.translations, 'welcome_message')}
              onChange={this.onWelcomeMessageChange}
              placeholder={t('NewsCenter::e.g. Welcome to our Help Center! How can we assist you today?')}
            />
          </div>

          <div className='form-item'>
            <label>{t('NewsCenter::Background color')}</label>
            <SwatchPickerContainer>
              <SwatchPicker
                color={newsCenter.header_background_color}
                onChange={this.onHeaderBackgroundColorChange}
              />
            </SwatchPickerContainer>
          </div>

          <div className='form-item'>
            <label>{t('NewsCenter::Text color')}</label>
            <SwatchPickerContainer>
              <SwatchPicker
                color={newsCenter.header_text_color}
                onChange={this.onHeaderTextColorChange}
              />
            </SwatchPickerContainer>
          </div>

          <div className='form-item'>
            <label>{t('NewsCenter::Header image')}</label>
            <AttachmentUploader
              url={newsCenter.header_image_url}
              onSubmit={this.onHeroImageChange}
              maxSize={HELP_CENTER_HERO_IMAGE_FILE_SIZE}
              accept={[
                MimeTypes.PNG,
                MimeTypes.JPEG,
                MimeTypes.JPG,
                MimeTypes.WEBP
              ]}
            />
          </div>

          <div className='form-item'>
            <div style={{ width: 'fit-content' }}>
              <CheckboxInput
                checked={newsCenter.header_background_fade}
                onChange={this.onHeroBackgroundFadeChange}
                label={t('NewsCenter::Fade background')}
              />
            </div>
          </div>

          <div className='form-item'>
            <label>{t('NewsCenter::Height')}</label>
            <input
              type='number'
              value={newsCenter.header_height}
              onChange={this.onHeroHeightChange}
              style={{ maxWidth: 100 }}
            />
          </div>
        </Accordion>

        <Accordion title={t('NewsCenter::News page')}>
          <div className='form-item'>
            <label>{t('NewsCenter::Table of contents')}</label>
            <p style={{ marginBottom: 8 }}>{t('NewsCenter::Table of contents is automatically generated from H1 and H2 headings in your news. It is available in your Help Center on the web and in the Messenger.')}</p>
            <div style={{ width: 'fit-content' }}>
              <CheckboxInput
                checked={newsCenter.table_of_contents_enabled}
                onChange={this.onTableOfContentsEnabledChange}
                label={t('NewsCenter::Show table of contents')}
              />
            </div>
          </div>
        </Accordion>
      </AccordionContainer>
    )
  }

  getPreviewUrl() {
    const { newsCenter, selectedLocale, selectedPage, news } = this.state

    if (!newsCenter) return ''

    let path = ''

    switch (selectedPage) {
      case NewsCenterPage.NEWS:
        if (news.length > 0) path = `news/${news[0].id}-${MobilityHelper.getTranslation(selectedLocale, news[0].translations, 'slug')}`
        break
    }

    if (path?.length === 0) {
      return [newsCenter.url, selectedLocale].join('/')
    } else {
      return [newsCenter.url, selectedLocale, path].join('/')
    }
  }

  render() {
    const { t, currentUser } = this.props
    const {
      viewMode,
      subviewMode,
      newsCenter,
      didInitialLoad,
      selectedLocale,
      selectedPage,
      browserSize,
      treeData,
    } = this.state

    const supportedLocaleOptions = NewsCenterHelper.getSupportedLocaleOptions(newsCenter)
    const selectedLocaleOption = supportedLocaleOptions.find(option => option.value === String(selectedLocale))

    const pageOptions = Object.keys(NewsCenterPage).map(key => {
      return { label: t(`NewsCenterPage::${NewsCenterPage[key]}`), value: NewsCenterPage[key] }
    })
    const selectedPageOption = pageOptions.find(option => option.value === String(selectedPage))

    const browserSizeOptions = Object.keys(BrowserSize).map(key => (
      { label: t(`BrowserSize::${BrowserSize[key]}`), value: BrowserSize[key] }
    ))
    const selectedBrowserSizeOption = browserSizeOptions.find(option => option.value === browserSize)

    return (
      <>
        <Helmet>
          <title>{t('NewsCenter::{{__appName}} | News center')}</title>
        </Helmet>

        <TopNavigation
          icon='book'
          title={t('NewsCenter::News center')}
        />

        <ScrollToTopOnMount />

        {!didInitialLoad && <PageLoaderContainer><PageLoader /></PageLoaderContainer>}

        {didInitialLoad && <FullPageContent>
          <Container>
            <Content>
              {viewMode === NewsCenterViewMode.CONTENT && <>
                <Header>
                  <HeaderActions>
                    <PowerSelect
                      options={supportedLocaleOptions}
                      value={selectedLocaleOption}
                      styles={{
                        container: () => ({ width: '150px' }),
                        menu: (provided) => ({
                          ...provided,
                          width: 'auto',
                          minWidth: '150px'
                        })
                      }}
                      onChange={this.onSelectedLocaleChange}
                    />
                  </HeaderActions>

                  <HeaderActions>
                    <Button
                      type='default'
                      icon='plus'
                      text={t('NewsCenter::Add news item')}
                      onClick={this.onAddNewsItemClick}
                    />
                  </HeaderActions>
                </Header>

                {treeData.length === 0 && <Card>
                  <CardEmptyInfo
                    icon='folder'
                    description={t('NewsCenter::No news articles have been created yet')}
                  />
                </Card>}

                {treeData.length > 0 && <Table>
                  <TableHeader>
                    <TableHeading>
                      {t('NewsCenter::Name')}
                    </TableHeading>
                    <TableActions />
                  </TableHeader>

                  <TableRows>
                    <ResizeObserver>
                      {({ width }) => {
                        return (
                          <Tree
                            data={treeData}
                            rowHeight={76.8}
                            width={width}
                            openByDefault={false}
                            idAccessor={(data) => `${data.type}-${data.model.id}`}
                            onMove={this.onItemMove}
                            disableDrop={this.disableDrop}
                            disableMultiSelection
                            indent={16}
                          >
                            {(props) => (
                              <Item
                                {...props}
                                newsCenterId={newsCenter.id}
                                locale={selectedLocale}
                                onClick={this.onItemClick}
                                onAddNewsClick={this.onAddNewsItemClick}
                                onEditClick={this.onItemEditClick}
                                onDeleteClick={this.onItemDeleteClick}
                              />
                            )}
                          </Tree>
                        )
                      }}
                    </ResizeObserver>
                  </TableRows>
                </Table>}
              </>}
              {viewMode === NewsCenterViewMode.SETTINGS && <>
                <Header>
                  <HeaderActions>
                    <Breadcrumb
                      content={t('NewsCenter::Back')}
                      url='javascript://'
                      onClick={this.onExitSettingsClick}
                    />
                  </HeaderActions>

                  <HeaderActions>
                    <ButtonGroup
                      items={[
                        { element: t('NewsCenter::General'), onClick: () => this.onSubviewModeChange(NewsCenterSubviewMode.GENERAL), active: subviewMode === NewsCenterSubviewMode.GENERAL },
                        { element: t('NewsCenter::Styling'), onClick: () => this.onSubviewModeChange(NewsCenterSubviewMode.STYLING), active: subviewMode === NewsCenterSubviewMode.STYLING }
                      ]}
                    />
                  </HeaderActions>
                </Header>

                {subviewMode === NewsCenterSubviewMode.GENERAL && this.renderGeneralSettings()}
                {subviewMode === NewsCenterSubviewMode.STYLING && this.renderStylingSettings()}
              </>}
            </Content>

            <Preview>
              <Header>
                <HeaderActions>
                  <PowerSelect
                    options={pageOptions}
                    value={selectedPageOption}
                    styles={{
                      container: () => ({ width: '150px' }),
                      menu: (provided) => ({
                        ...provided,
                        width: 'auto',
                        minWidth: '150px'
                      })
                    }}
                    onChange={this.onPageChange}
                  />
                </HeaderActions>

                <HeaderActions>
                  <SimpleTooltip content={t('NewsCenter::News center settings')}>
                    <div>
                      <IconButton
                        icon='setting'
                        onClick={this.onSettingsClick}
                      />
                    </div>
                  </SimpleTooltip>

                  <PowerSelect
                    options={browserSizeOptions}
                    value={selectedBrowserSizeOption}
                    styles={{
                      container: () => ({ width: '150px' }),
                      menu: (provided) => ({
                        ...provided,
                        width: 'auto',
                        minWidth: '150px'
                      })
                    }}
                    onChange={this.onBrowserSizeChange}
                  />
                </HeaderActions>
              </Header>

              <BrowserPreview>
                <BrowserContainer size={browserSize}>
                  <Browser>
                    <BrowserHeader onClick={this.onNewsCenterCopyUrlClick}>
                      <BrowserUrl>
                        <span>{this.getPreviewUrl()}</span>
                      </BrowserUrl>
                    </BrowserHeader>

                    <ResizeObserver>
                      {({ width, height }) => {
                        let scale = 1;
                        let contentWidth = width;
                        let contentHeight = height;
                        let xOffset = 0;

                        if (browserSize === BrowserSize.DESKTOP) {
                          contentWidth = 1200;
                          scale = width / contentWidth;
                          contentHeight = height / scale;
                          xOffset = (width - contentWidth * scale) / 2;
                        } else if (browserSize === BrowserSize.TABLET) {
                          contentWidth = 768;
                          scale = width / contentWidth;
                          contentHeight = height / scale;
                          xOffset = (width - contentWidth * scale) / 2;
                        } else if (browserSize === BrowserSize.MOBILE) {
                          contentWidth = 375;
                          scale = width / contentWidth;
                          contentHeight = height / scale;
                          xOffset = (width - contentWidth * scale) / 2;
                        }
                        return (
                          <BrowserContentContainer
                            style={{
                              left: 1,
                              top: 40,
                              width: contentWidth,
                              height: contentHeight,
                              borderRadius: Style.variables.baseBorderRadius,
                              transform: `scale(${scale})`,
                              transformOrigin: 'top left',
                            }}
                          >
                            <BrowserContent src={this.getPreviewUrl()} />
                          </BrowserContentContainer>
                        )
                      }}
                    </ResizeObserver>

                  </Browser>
                </BrowserContainer>
              </BrowserPreview>
            </Preview>
          </Container>
        </FullPageContent>}
      </>
    )
  }
}

const mapStateToProps = (state: AppState): IStateToProps => {
  const {
    authentication: {
      currentUser,
    },
  } = state

  return {
    currentUser: currentUser,
  }
}

const mapDispatchToProps: IDispatchToProps = {
  showNewsCenterModal,
  showNewsModal,
  showConfirmModal,
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(NewsCenter))